import { useEffect as t } from "react";
import p from "../../../store/useStore.js";
import { server as E } from "../../../config/axios.js";
import { DEFAULT_TOKEN as J, CARDANO_TOKEN as l, DEFAULT_TOKEN_LIST as O } from "../tokens.js";
import { useWalletConnect as oo } from "../../../hooks/useWalletConnect.js";
import { wallets as ro } from "../../../constants/wallets.js";
import { hexToAscii as U } from "../../../utils/cardanoUtils.js";
import { u as v } from "../../../useQuery-714c7c61.js";
import "../../../_commonjsHelpers-10dfc225.js";
import "../../../index-9d43cc8b.js";
import "../../../store/createTokenSearchSlice.js";
import "../../../immer-548168ec.js";
import "../../../store/createWalletSlice.js";
import "../../../store/createSwapSettingsSlice.js";
import "../../../store/createGlobalSettingsSlice.js";
import "../../../store/createUserOrdersSlice.js";
import "../../../store/createSwapSlice.js";
import "../../../store/createChartSlice.js";
import "../../../store/createBasketSlice.js";
import "../../../store/createModalWhatsNewSlice.js";
import "../../../store/createSwapParamsSlice.js";
import "../../../index-ca8eb9e1.js";
import "../../../axios-ddd885c5.js";
import "../../../config/decrypt.js";
import "../../../QueryClientProvider-103c6f38.js";
import "../../../notifyManager-b5b16d35.js";
const To = ({
  searchParams: W,
  defaultToken: m,
  orderTypes: N,
  supportedTokens: s,
  partnerName: k,
  partnerCode: S,
  onSwapSuccess: _,
  onSwapError: B,
  selectedWallet: h,
  inputs: L,
  onWalletConnect: z,
  onClickWalletConnect: u,
  onViewOrder: T,
  orderTypeOnButtonClick: A,
  defaultSettings: r
}) => {
  const {
    setTokenBuy: n,
    setTokenSell: w,
    setSellAmount: G,
    setOrderTypes: R,
    setOnSwapSuccess: b,
    setOnSwapError: C,
    setOnViewOrder: D,
    setOrderType: F
  } = p((o) => o.swapSlice), { setSwapType: x, setSupportedTokens: M } = p(
    (o) => o.tokenSearchSlice
  ), {
    setIsHideSmallBalances: Y,
    setDefaultBuySize: $,
    setIsAdvancedMode: j,
    setPartner: K,
    setInputs: g
  } = p((o) => o.globalSettingsSlice), {
    setAvailableWallets: P,
    setIsLoadingWallet: Q,
    resetWallet: q,
    setOnClickWalletConnect: V
  } = p((o) => o.walletSlice), {
    setSlippage: X,
    setIsAutomaticSlippage: Z,
    setIsCustomSlippage: d
  } = p((o) => o.swapSettingsSlice), { reconnectToWallet: H } = oo(z), { data: c } = v(
    ["tokenListSetup"],
    async () => {
      let o = [];
      try {
        const { data: i } = await E.get("/swap/tokens");
        o = [{ ...l }, ...i];
      } catch (i) {
        console.log("Get token list on setup fail: ", i), o = Object.values(O);
      }
      return o.reduce((i, f) => (i[f.token_id] = f, i), {});
    },
    {
      refetchInterval: 3e4
    }
  );
  t(() => {
    (r == null ? void 0 : r.slippage) !== void 0 && (r == null ? void 0 : r.slippage) !== null && X(r.slippage), (r == null ? void 0 : r.isAutomaticSlippage) !== void 0 && (r == null ? void 0 : r.isAutomaticSlippage) !== null && Z(r.isAutomaticSlippage), (r == null ? void 0 : r.isCustomSlippage) !== void 0 && (r == null ? void 0 : r.isCustomSlippage) !== null && d(r.isCustomSlippage);
  }, [JSON.stringify(r)]), t(() => {
    V(
      u || void 0
    );
  }, [u]);
  const {
    tokenIdSell: a,
    tokenIdBuy: I
  } = W, y = !a && !I;
  let e = J.token_id;
  m && (e = m), s && s.length > 0 && !m && (e = s[0]), t(() => {
    if (c) {
      if (M(
        s && s.length > 0 ? s : []
      ), y) {
        x("BUY"), w(l), n(
          c[e] || O[e]
        );
        return;
      }
      w(c[a] || O[a]), n(c[I] || O[I]);
    }
  }, [
    y,
    m,
    JSON.stringify(s),
    JSON.stringify(c)
  ]), t(() => {
    g(L);
  }, [L, g]), t(() => {
    R(N);
  }, [N, R]), t(() => {
    A && F(A);
  }, [A, F]), t(() => {
    K(k, S);
  }, [k, S, K]), t(() => {
    b(_), C(B), D(T);
  }, [
    _,
    B,
    b,
    C,
    T,
    D
  ]), t(() => {
    const o = localStorage.getItem("globalSettings");
    if (o) {
      const i = JSON.parse(o);
      Y(i.isHideSmallBalances), $(i.defaultBuySize), j(i.isAdvancedMode), a === "" && G(i.defaultBuySize);
    }
  }, []), t(() => {
    h || (q(), Q(!1)), H(h);
  }, [h]), t(() => {
    const o = ro.filter((i) => {
      if (i.alwaysShow)
        return !0;
      try {
        return window.cardano[i.windowName];
      } catch {
        return !1;
      }
    });
    P(o);
  }, []), t(() => {
    var o;
    if ((o = window.cardano) != null && o.onAccountChange) {
      const i = () => {
        H();
      };
      window.cardano.onAccountChange(i);
    }
  }, []), v(
    ["tokenSellInfo", a],
    async () => {
      try {
        if (!a || y)
          return w(l), !0;
        const { data: o } = await E.get(
          `/swap/token/${a}`
        );
        return w(o), o;
      } catch (o) {
        return console.log("ERROR FETCHING SELL TOKEN", o), l;
      }
    },
    { refetchOnWindowFocus: !1 }
  ), v(
    ["tokenBuyInfo", e, c],
    async () => {
      try {
        if (y && c && c[e])
          return n(c[e]), !0;
        if (!e)
          return n(l), !0;
        const o = await E.get(`/swap/token/${e}`).catch(() => {
          e && n({
            token_id: e,
            token_policy: e.slice(0, 56),
            token_ascii: U(e.slice(56)),
            is_verified: !1,
            ticker: U(e.slice(56))
          });
        });
        return n(o == null ? void 0 : o.data), !0;
      } catch (o) {
        return console.log("ERROR FETCHING BUY TOKEN", o), J;
      }
    },
    { refetchOnWindowFocus: !1 }
  );
};
export {
  To as useSwapSetup
};
